import { Dispatch } from 'react'

import {
  addSelectedContribution,
  clearSelectedContributions,
} from 'redux/slices/TextAnalysis'
import { TAResponseProps } from 'types/TextAnalysis'

export const isCardSelected = (
  item: TAResponseProps,
  selectedCards: TAResponseProps[],
) => {
  const alreadySelected = selectedCards.some(
    (selectedCard: TAResponseProps) => selectedCard.id === item.id,
  )
  return alreadySelected
}

export const handleCheckboxClickHelper = (
  item: TAResponseProps,
  selectedCards: TAResponseProps[],
  dispatch: Dispatch<any>,
) => {
  const alreadySelected = isCardSelected(item, selectedCards)

  if (alreadySelected) {
    const updatedCards = selectedCards.filter(
      (selectedCard: TAResponseProps) => selectedCard.id !== item.id,
    )
    dispatch(clearSelectedContributions(updatedCards))
  } else {
    dispatch(addSelectedContribution(item))
  }
}

export const getCurrentIds = (currentRows: any[]) =>
  currentRows.map((row) => row.id)

export const getSelectedCurrentRows = (
  selectedRows: any[],
  currentRows: any[],
) => selectedRows.filter(({ id }) => getCurrentIds(currentRows).includes(id))

export const calculateIsIndeterminate = (
  currentRows: any[],
  selectedRows: any[],
) =>
  currentRows.length > 0 &&
  selectedRows.length > 0 &&
  getSelectedCurrentRows(selectedRows, currentRows).length > 0 &&
  getSelectedCurrentRows(selectedRows, currentRows).length < currentRows.length

export const calculateIsChecked = (currentRows: any[], selectedRows: any[]) =>
  currentRows.length > 0 &&
  getSelectedCurrentRows(selectedRows, currentRows).length ===
    currentRows.length

export const getFilteredRows = (currentRows: any[], selectedRows: any[]) =>
  selectedRows.filter(({ id }) => !getCurrentIds(currentRows).includes(id))

export const handleAddNewBulkTag = (tags: any[], contributions: any[]) => {
  const contribution_ids = contributions.map((item) => item.id)
  return {
    tags,
    contribution_ids,
  }
}
